import React from "react";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";
import { useNavigate } from "react-router-dom";
const PasswordChangedSuccess = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full md:w-1/2 flex flex-col items-center justify-center p-8 bg-white">
      <img
        src={logo}
        alt="LogIn Info"
        className="absolute top-4 left-4 w-28 h-auto hover:cursor-pointer"
        onClick={() => navigate("/")}
      />
      <h1 className="text-3xl font-bold text-purple-800 mb-2">
        Password Changed Successfully
      </h1>
      <p className="text-gray-500">
        Your Password has been Updated You can use
      </p>
      <p className="text-gray-500 mb-6">your new Pasword to login securely</p>
      <div className="w-full max-w-md">
        <button
          onClick={(e) => {
            navigate("/auth/login");
          }}
          className="w-full py-3 text-white bg-gradient-to-r from-pink-500 to-blue-700 rounded-lg shadow-md hover:opacity-90 transition-all"
        >
          Log In Now
        </button>
      </div>
    </div>
  );
};

export default PasswordChangedSuccess;
